/**
 * FERP Portal - Evidence/Document List Page (DRR-074: Tabulator DRY Template)
 *
 * EXECUTE Phase: Documents and evidence artifacts for audit trails and compliance.
 * Delegates to TabulatorPrimitiveManager for consistent CRUD across all 25 primitives.
 */

import { TabulatorPrimitiveManager } from '@/components/primitives/TabulatorPrimitiveManager';

export function EvidenceListPage() {
  return <TabulatorPrimitiveManager primitiveType="document" />;
}

export default EvidenceListPage;
